module.exports = __webpack_public_path__ + "img/unicom.aba9f384.svg";